<template>
  <div>OauthCode</div>
</template>

<script>
import Config from '@/config'

export default {
  name: 'OauthCode',
  mounted() {
    this.fetchToken()
  },
  methods: {
    async fetchToken() {
      try {
        const res = await this.$user.fetchTokenByAuthCode(Config.appEnv)

        console.warn('[success_auth]', res)
      } catch (e) {
        console.error('[error: fetchToken]', e)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "./src/front_white/sass/components/settings";
</style>
